export const SearchConf = {
  query: {
    keys: [
      {
        key: 'id_yacht.yacht_name',
        operator: '$containsi',
      },
      {
        key: 'id_agent_NA.id_users_permissions_user.name',
        operator: '$containsi',
      },
      {
        key: 'id_agent_NA.id_users_permissions_user.surname',
        operator: '$containsi',
      },
      {
        key: 'id_yacht.yacht_type',
        operator: '$containsi',
      },
      {
        key: 'id_user_provision.id_users_permissions_user.name',
        operator: '$containsi',
      },
      {
        key: 'id_user_provision.id_users_permissions_user.surname',
        operator: '$containsi',
      },
      {
        key: 'id_provenence_list.provenence.provenence',
        operator: '$containsi',
      },
      {
        key: 'formalities',
        operator: '$containsi',
      },
      {
        key: 'id_provenence_list.provenence_group.group',
        operator: '$containsi',
      },
      {
        key: 'mexal_code',
        operator: '$containsi',
      },
      {
        key: 'isps',
        operator: '$containsi',
      },
      {
        key: 'garbage',
        operator: '$containsi',
      },
    ],
  },
  placeholder: 'Search',
  initialState: {
    value: '',
  },
};
